module.exports = __webpack_public_path__ + "img/2023-14.20453c2c.jpg";